import {
  Dropdown,
  makeStyles,
  Option,
  Text,
  tokens,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { DataContext } from "../../context/DataContext";
import { useContext } from "react";
import { ICustomer } from "../../interfaces/ICustomer";
import { ApiContext } from "../../Root";
import { useAuth } from "../../authentication/AuthContextProvider";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    lineHeight: tokens.lineHeightBase400,
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorBrandBackground,
  },
  subTitle: {
    lineHeight: tokens.lineHeightBase600,
    fontSize: tokens.fontSizeBase500,
    fontWeight: tokens.fontWeightSemibold,
  },
  customerDropdown: {
    minWidth: "200px",
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase500,
    marginTop: tokens.spacingVerticalS,
  },
});

export const Message = (): JSX.Element => {
  const styles = useStyles();
  const dataContext = useContext(DataContext);
  const apiContext = useContext(ApiContext);
  const auth = useAuth();
  const { authUser, customers, selectedCustomer, isLoading } = dataContext.state;
  const { t } = useTranslation();

  const handleCustomerChange = async (customer: ICustomer) => {
    localStorage.setItem(`selectedCustomer_${authUser?.id}`, String(customer.id));
    dataContext.setRootState((prev) => ({
      ...prev,
      selectedCustomer: customer,
      orders: [],
      tickets: [],
      ticketsNextPageToken: null,
    }));
    await Promise.all([
      apiContext.customerOrderApi.getOrders(dataContext, auth.user, customer, t),
      apiContext.customerOrderApi.getTickets(dataContext, auth.user, customer, t),
    ]);
  };

  return (
    <div className={styles.container}>
      <Text className={styles.title}>
        {authUser?.title
          ? `${t("texts.welcomeMessage")} ${authUser?.title.split(" ")[0]}!`
          : `${t("texts.welcomeMessageWithoutUserTitle")}`}
      </Text>

      {customers?.length > 1 ? (
        <Dropdown
          className={styles.customerDropdown}
          appearance="underline"
          disabled={isLoading}
          value={selectedCustomer?.title ?? ""}
          selectedOptions={
            selectedCustomer ? [String(selectedCustomer.id)] : []
          }
          onOptionSelect={(_, data) => {
            const chosen = customers.find(
              (c) => String(c.id) === data.optionValue
            );
            if (chosen) handleCustomerChange(chosen);
          }}
        >
          {customers.map((c) => (
            <Option key={c.id} value={String(c.id)}>
              {c.title}
            </Option>
          ))}
        </Dropdown>
      ) : (
        <Text className={styles.subTitle}>{selectedCustomer?.title}</Text>
      )}
    </div>
  );
};
